import { AppState } from 'src/ducks';
import { withLoadingSelectors } from 'src/ducks/factories/loading';
import { withPaginationSelectors } from 'src/ducks/factories/pagination';
import { withSearchSelectors } from 'src/ducks/factories/search';

export const __REDUX_STATE_KEY__ = 'channelsManagement';
export const getReduxStateSlice = (state: AppState) => state[__REDUX_STATE_KEY__];

export const getChannelManagement = (state: AppState) => getReduxStateSlice(state).list;
export const getChannelManagementCount = (state: AppState) => getReduxStateSlice(state).countItems;
export const getSelectedChannels = (state: AppState) => getReduxStateSlice(state).selected;

export const channelsManagementLoadingSelectors = withLoadingSelectors(__REDUX_STATE_KEY__);

export const channelsManagementPaginationSelectors = withPaginationSelectors(__REDUX_STATE_KEY__);

export const channelsManagementSearchSelectors = withSearchSelectors(__REDUX_STATE_KEY__);
